import type { ReactNode } from "react";
import "../styles/sidebar-layout.css";

/** Layout containers only; ad placement is controlled by the ad provider. */
export function SidebarLayout({ children }: { children: ReactNode }) {
  return (
    <div className="sidebar-layout">
      <aside id="ad-sidebar-left" className="journey-sidebar ad-sidebar ad-sidebar-left" aria-label="Left advertising sidebar" />
      {children}
      <aside id="ad-sidebar-right" className="journey-sidebar ad-sidebar ad-sidebar-right" aria-label="Right advertising sidebar" />
    </div>
  );
}
